export class FeatureValue {
    constructor(
        public Value?: any,
        public IsExistsInStock?:number
    ) { }
}